import { DigitalWalletManagementRowResult } from "@/models/digital.wallet";
import digitalWalletStore from "@/stores/digital.wallet.store";
import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IBulkWalletsUpdateStepOne {
    handleNext: () => void;
}

const BulkWalletsUpdateStepOne: FC<IBulkWalletsUpdateStepOne> = ({ handleNext }: IBulkWalletsUpdateStepOne) => {
    const { t } = useTranslation();
    const [type, setType] = useState<number>();
    const request = digitalWalletStore.bulkUpdateDigitalWalletsRequest;
    const onHandleNext = (type: number) => {
        const newValue = { ...request, type: type, amount: 0, expiredDate: null, isReset: false };
        digitalWalletStore.setBulkUpdateDigitalWalletsRequest(newValue);
        setType(type);
    };

    function handleNewEmployee(digitalWallets: DigitalWalletManagementRowResult[]) {
        const selectedWallets = digitalWalletStore.walletSelectionModel;
        const result = digitalWallets.find(
            (wallet) => selectedWallets.includes(wallet.id) && wallet.walletStatus === "NotEstablished"
        );

        if (result != null) {
            return true;
        } else {
            return false;
        }
    }

    function handleNotActiveEmployee(digitalWallets: DigitalWalletManagementRowResult[]) {
        const selectedWallets = digitalWalletStore.walletSelectionModel;
        const result = digitalWallets.find(
            (wallet) => selectedWallets.includes(wallet.id) && wallet.walletStatus === "NotActive"
        );

        if (result != null) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        if (type && type > 0) {
            handleNext();
        }
    }, [type]);

    return (
        <Grid className="bulk-update-steps-content">
            <Grid className="bulk-update-steps-title">{t("digitalWallet.ChooseCurrentOperationType")}</Grid>
            <Grid className="bulk-update-step-one-content">
                {(!handleNewEmployee(digitalWalletStore.digitalWalletsStore) &&
                    !handleNotActiveEmployee(digitalWalletStore.digitalWalletsStore)) && (
                        <Grid
                            className={`bulk-update-step-one-content-item ${request.type === 1 ? "active" : ""}`}
                            onClick={() => onHandleNext(1)}
                        >
                            <Grid className="bulk-update-step-one-circle">
                                <i className="icon-f icon-amount-icon fs-24" />
                            </Grid>
                            <Grid sx={{ paddingTop: "19px" }} className="bulk-update-step-one-description">
                                {t("digitalWallet.LoadingAmount")}
                            </Grid>
                        </Grid>
                    )}
                <Grid
                    className={`bulk-update-step-one-content-item ${request.type === 2 ? "active" : ""}`}
                    onClick={() => onHandleNext(2)}
                >
                    <Grid
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "15px",
                        }}
                    >
                        <Grid className="bulk-update-step-one-circle">
                            <i className="icon-f icon-amount-icon fs-24" />
                        </Grid>
                        <Grid className="bulk-update-step-one-circle">
                            <i className="icon-f icon-calendar-icon fs-24" />
                        </Grid>
                    </Grid>
                    <Grid sx={{ paddingTop: "10px" }} className="bulk-update-step-one-description">
                        {t("digitalWallet.LoadingAmountAndNewExpiryDates")}
                    </Grid>
                </Grid>
                {!handleNewEmployee(digitalWalletStore.digitalWalletsStore) && (
                    <Grid
                        className={`bulk-update-step-one-content-item ${request.type === 3 ? "active" : ""}`}
                        onClick={() => onHandleNext(3)}
                    >
                        <Grid className="bulk-update-step-one-circle">
                            <i className="icon-f icon-calendar-icon fs-24" />
                        </Grid>
                        <Grid sx={{ paddingTop: "19px" }} className="bulk-update-step-one-description">
                            {t("digitalWallet.NewExpiryDates")}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default BulkWalletsUpdateStepOne;
